export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';

// Short-lived, single-use cookie carrying a CSRF nonce that must match the
// one embedded in the OAuth `state` parameter on callback (see #83).
export const OAUTH_CSRF_COOKIE_NAME = "oauth_csrf_state";
export const OAUTH_CSRF_NONCE_MAX_AGE_MS = 1000 * 60 * 10;
